import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
// import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import MainLogo from "../../../../assets/svg/main_logo.svg";

const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Perfomance na geração de respostas ao STA',
    description:
      'Geração em tempo real de respostas ao STA (Sistema de Transferência de Arquivos), cruzando os dados de clientes da Fiducia com os de parceiros no banco de dados.',
  },
  // {
  //   icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
  //   title: 'Built to last',
  //   description:
  //     'Experience unmatched durability that goes above and beyond with lasting investment.',
  // },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Melhor experiência do usuário',
    description:
      'Design intuitivo e responsivo, a resposta do STA em um click.',
  },
  // {
  //   icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
  //   title: 'Innovative functionality',
  //   description:
  //     'Stay ahead with features that set new standards, addressing your evolving needs better than the rest.',
  // },
];

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        {/* Icone fiducia */}
        {/* <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
          Logo Fiducia
        </Typography> */}
         <Box
              component="img"
              src={MainLogo}
              alt="Svg em construção"
              sx={{
                maxWidth: "100%",
                maxheight: "100%",
                marginBottom: 2,
              }}
            />
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}